type StatCardProps = {
  label: string;
  value: string;
  format?: string;
  hasBorder?: boolean;
};
export const StatCard = ({
  label,
  value,
  format = "text-base font-bold text-dark",
  hasBorder,
}: StatCardProps) => {
  return (
    <>
      <div
        className={`w-full bg-white rounded-xl p-2 flex flex-col justify-between h-[8vh] ${hasBorder ? "border-1" : ""}`}
      >
        <span className="text-xs text-slate-600">{label}</span>
        <span className={format}>{value}</span>
      </div>
    </>
  );
};
